import { debounce, isEmpty } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import moment from "moment";
import { motion } from "framer-motion";
import NoEvent from "../../component/NoEvent";
import { isMobile } from "react-device-detect";
import ThemeContext from "../../context/ThemeContext";
import { useContextSelector } from "use-context-selector";
const Search = ({ setSearch }) => {
  const [input, setInput] = useState("");
  const [object, setObject] = useState({
    circket: 0,
    tennis: 0,
    soccer: 0,
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const [list, setList] = useState([]);
  const navigate = useNavigate();
  const [series, setSeries] = useState([]);
  const [tab, setTab] = useState("cricket");
  const debounceFn = useMemo(() => debounce(handleDebounceFn, 500), []);
  const [singleSelect, setSingleSelect] = useState([]);
  const groupMatchesBySeries = (matches, searchText = "") => {
    return matches.reduce((acc, match) => {
      const series = match?.seriesName || "Unknown Series";
      if (!acc[series]) acc[series] = [];
      acc[series].push(match);
      return acc;
    }, {});
  };
  const getData = async (value) => {
    if (isEmpty(value)) {
      setList([]);
    } else {
      const { status, data } = await apiGet(apiPath.searchEvent, {
        keyword: value,
      });
      if (data?.success === true) {
        setList(data?.results);
        setSeries(Object.entries(groupMatchesBySeries(data?.results, value)));
      }
    }
  };
  function handleDebounceFn(inputValue) {
    getData(inputValue);
  }

  function handleChange(event) {
    setInput(event.target.value);
    debounceFn(event.target.value);
  }

  const highlightText = (text) => {
    if (!input) return text;

    const regex = new RegExp(`(${input})`, "gi");
    const parts = text.split(regex);

    return (
      <span data-v-753c62c9>
        {parts.map((part, index) =>
          part.toLowerCase() === input.toLowerCase() ? (
            <span
              key={index}
              className="s-text-back-600-light dark:s-text-back-600-dark"
            >
              {part}
            </span>
          ) : (
            part
          )
        )}
      </span>
    );
  };
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }

  const sportsTabs = [
    {
      key: "cricket",
      label: "Cricket",
      icon: "s-icon-cricket",
      count: object?.circket,
      isSelected: false,
    },
    {
      key: "soccer",
      label: "Soccer",
      icon: "s-icon-soccer",
      count: object?.soccer,
      isSelected: false,
    },
    {
      key: "tennis",
      label: "Tennis",
      icon: "s-icon-tennis",
      count: object?.tennis,
      isSelected: false,
    },
  ];

  const Events = ({ list }) => {
    return (
      <div className="s-rounded-xl s-text-black s-bg-white dark:s-bg-main-block-dark s-divide-y s-divide-black-300 dark:s-divide-black-900">
        {list?.map((res) => {
          return (
            <div
              onClick={() =>
                navigate(`/match-detail/${res?.eventId}/${res?.marketId}`)
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              data-v-753c62c9
              className="s-event-row s-grid s-gap-14px s-py-7px s-px-14px s-justify-between s-items-center"
              data-should-render-scores-column="true"
            >
              <div data-v-753c62c9 className="s-flex s-flex-col">
                <div
                  data-v-753c62c9
                  className="s-flex s-justify-between s-items-center s-gap-10px"
                >
                  <div
                    data-v-753c62c9
                    className="s-text-17px s-font-bold s-leading-120 s-break-words s-text-global-font-default-light dark:s-text-global-font-default-dark"
                  >
                    {highlightText(res?.eventName)}
                  </div>
                </div>
                <div
                  data-v-753c62c9
                  className="s-flex s-py-2px s-gap-3px s-leading-14px"
                >
                  <div data-v-753c62c9>
                    {res?.status == "in_play" ? (
                      <div
                        data-v-88ac4f64
                        className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                      >
                        <div className="s-px-3px s-leading-14px s-flex s-items-center s-justify-center s-bg-inPlay-light dark:s-bg-inPlay-dark s-text-black s-flex-1">
                          <span className="s-text-12px s-leading-120 s-text-center">
                            In-play
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div
                        data-v-88ac4f64
                        className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                      >
                        <div className="s-time-block s-flex s-items-center s-justify-center s-flex-1 s-bg-today-light dark:s-bg-today-dark">
                          <span className="s-text-12px s-leading-120 s-text-black s-text-center s-whitespace-nowrap s-px-3px s-py-0">
                            {isDateToday(res?.eventDateTime)
                              ? "Today"
                              : moment(res?.eventDateTime).format("DD/MM")}
                          </span>
                          <span className="s-text-12px s-leading-120 s-text-black s-text-center s-pr-3px">
                            {moment(res?.eventDateTime).format("HH:MM")}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    data-v-753c62c9
                    className="s-text-12px s-font-normal s-leading-120 s-text-black-600"
                  >
                    <span data-v-753c62c9 className="s-pr-1">
                      Matched
                    </span>
                    <span data-v-753c62c9>0</span>
                  </div>
                </div>
              </div>
              <div
                data-v-753c62c9
                className="s-flex s-gap-10px s-justify-end s-items-center"
              >
                <span
                  data-v-753c62c9
                  className="s-block s-icon-arrow-left s-transform s-rotate-180 s-text-12px s-text-black-500"
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <>
      <div
        data-v-d56e9d5a
        className="s-modal-mask s-fixed s-top-0 s-left-0 s-bottom-0 s-w-full s-bg-black/50 s-backdrop-blur-[2px] s-w-full"
        style={{
          display: "none",
          "-622e6b4e": "300",
          "-302f011b": "100%",
          "-183a105a": "100vh - 3rem",
        }}
      />
      <div
        data-v-d56e9d5a
        className="s-modal-container s-fixed s-bottom-0 s-flex-col s-bg-pop-title-bg s-text-global-font-default-light dark:s-text-global-font-default-dark s-px-3px s-rounded-t-5px s-w-full"
        style={{
          display: "none",
          "-622e6b4e": "300",
          "-302f011b": "100%",
          "-183a105a": "100vh - 3rem",
        }}
      >
        <div
          data-v-d56e9d5a
          className="s-relative s-modal-title s-py-4 s-bg-pop-title-bg"
        >
          <h4
            data-v-d56e9d5a
            className="s-mb-0 s-font-bold s-text-17px s-text-center s-text-pop-title-text"
          />
          <span
            data-v-d56e9d5a
            className="s-icon-close s-absolute s-right-4 s-top-1/2 -s-translate-y-1/2 s-text-pop-title-text s-text-base"
          />
        </div>
        <div data-v-d56e9d5a>
          <div
            data-v-d56e9d5a
            className="s-modal-content s-px-24px s-pt-14px s-leading-6 s-rounded-t-3px s-bg-betSlip-light dark:s-bg-black-800 s-overflow-y-scroll"
          />
        </div>
      </div>
      <div
        data-v-6e371132
        className="s-search-mask s-w-full s-h-full s-fixed s-top-0 s-left-0 s-bg-black/50 s-backdrop-blur-[2px]"
        style={{
          "-115eec0f": "70",
          "-23b2bef2": isMobile ? "100%" : `100% - 60px`,
        }}
      />
      <section
        data-v-6e371132
        className={`s-search-modal s-bg-body s-overflow-hidden s-fixed ${
          isMobile ? "s-w-full s-top-0" : "s-w-desktop s-bottom-0"
        }`}
        style={{
          "--115eec0f": "70",
          "--23b2bef2": isMobile ? "100%" : `100% - 60px`,
        }}
      >
        <div data-v-6e371132 className="s-sticky s-top-0 s-z-10">
          <div
            data-v-6e371132
            id="s-search-input"
            className="s-h-44px s-p-3 s-bg-black dark:s-bg-secondary s-text-white s-text-14px s-flex s-items-center s-justify-center"
          >
            <input
              data-v-6e371132
              onChange={(e) => handleChange(e)}
              value={input}
              id="search"
              style={theme == 'light' && isMobile ? {background:"#37383c"} : {}}
              name="search"
              autoComplete="true"
              type="string"
              className="s-effect-20 s-relative s-w-full s-h-40px s-px-2 s-z-10 s-bg-white s-bg-opacity-0 s-placeholder:text-white"
              placeholder="Search teams, competitions, and more..."
            />
            <span
              onClick={() => setSearch(false)}
              data-v-6e371132
              className="s-icon-close s-text-14px s-ml-7px"
            />
          </div>
        </div>

        <div
          data-v-6e371132
          id="searchContainer"
          style={theme == 'light' ?  {background:"#20232a"} : {}}
          className="s-h-full s-pb-94px s-overflow-y-scroll s-text-global-font-default-light dark:s-text-global-font-default-dark dark:s-bg-main-background-dark"
        >
          {isEmpty(singleSelect) ? (
            <div data-v-6e371132>
              {series?.length > 0 && (
                <section data-v-6e371132>
                  <div className="s-px-4">
                    <div className="s-pt-14px s-pb-6px s-text-15px s-leading-21px s-text-category-title">
                      Competitions
                    </div>
                    <div className="s-bg-betSlip-light dark:s-bg-white dark:s-bg-opacity-5 s-rounded-5px s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-15px s-leading-tight s-divide-y s-divide-black-300 dark:s-divide-black-900">
                      {series?.map((res) => {
                        return (
                          <div
                            onClick={() =>
                              setSingleSelect({ title: res[0], list: res[1] })
                            }
                            className="s-flex s-py-10px s-px-14px s-justify-between s-items-center s-shadow-2sm"
                          >
                            <div className="s-text-17px s-font-bold s-leading-140">
                              {highlightText(res[0])}
                            </div>
                            <span className="s-icon-arrow-left s-transform s-rotate-180 s-text-12px s-text-black-500" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </section>
              )}
              {list?.length > 0 && !isEmpty(input) ? (
                <section data-v-6e371132 className="s-px-4 s-py-14px">
                  <div
                    data-v-6e371132
                    className="s-pb-6px s-text-15px s-leading-21px s-text-category-title"
                  >
                    Event
                  </div>
                  <Events list={list} />
                </section>
              ) : (
                <NoEvent />
              )}
            </div>
          ) : (
            <section className="s-px-4 s-py-14px">
              <div className="s-bg-white dark:s-bg-main-block-dark s-rounded-xl s-text-black s-text-15px s-leading-tight s-divide-y s-divide-black-300">
                <div className="s-flex s-py-4 s-pl-4 s-pr-2 s-mb-16px s-items-center">
                  <div
                    onClick={() => setSingleSelect({})}
                    className="s-pr-2 s-border-r s-border-r-black-300 s-text-black-500"
                  >
                    <span className="s-pr-2 s-icon-arrow-left s-text-12px" />
                    <span className="s-text-15px">Back</span>
                  </div>
                  <span className="s-pl-4 s-text-15px s-truncate s-text-global-font-default-light dark:s-text-global-font-default-dark">
                    {singleSelect?.title}
                  </span>
                </div>
              </div>
              <Events list={singleSelect?.list} />
            </section>
          )}
        </div>
      </section>{" "}
    </>
  );
};

export default Search;
